import { Label, Stack } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { TagPicker } from 'office-ui-fabric-react/lib/Pickers';
import React, { Component, Fragment } from 'react';
import { Data } from '../../data/Data.jsx';
import { DataTicket } from '../../data/DataTicket';
import { Immocom } from '../../specifique/immocom';
import { EUITextField } from '../EUI/EUITextField.jsx';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { PickerEmail } from '../Picker/PickerEmail.jsx';

export class FicheEnvoiEmail extends Component {

    static defaultProps = {
        corps: "",
        emails: [],
        from: "",
        idsTickets: [], // Si idsTickets est passé en props cela signifie qu'on appelle la FicheEnvoiEmail depuis l'administration des tickets ; le comportement n'est pas le même
        isOpen: false,
        onDismiss: () => null,
        onSend: (destinataires) => null,
        sujet: "",
        idOperation: 0,
        idReservation: 0,
    };

    static defaultState = {
        sujet: "",
        corps: "",
        emailsSelectionnes: [],
        emailsCcSelectionnes: [],
        emailsCciSelectionnes: [],
        loginsComptesSelectionnes: [],
        onActiveBoutonEnregistrer: true,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheEnvoiEmail.defaultState };
    }

    _envoyer = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Envoi du mail en cours"
        });

        const { idsTickets, onSend, emails, from } = this.props;
        const { loginsComptesSelectionnes, emailsSelectionnes, emailsCcSelectionnes, emailsCciSelectionnes, sujet } = this.state;
        let corps = (this.state.corps || "").replace(/\r\n|\r|\n/g, "<br/>"); // 09/12/2021 : en attendant validation composant WYSIWYG

        let method = null;
        if (!!emails && emails.length > 0)
            method = () => Data._envoyerEmail(emailsSelectionnes, emailsCcSelectionnes, emailsCciSelectionnes, sujet, corps, from);
        else if (!!idsTickets && idsTickets.length > 0)
            method = () => Data._envoyerEmailAuxCompteEtMAJDesTickets(loginsComptesSelectionnes, sujet, corps);

        if (!!method) method().then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                let destinataires = [];
                if (!!emails && emails.length > 0) {
                    destinataires = emailsSelectionnes
                        .concat(emailsCcSelectionnes)
                        .concat(emailsCciSelectionnes);
                }
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, () => onSend(destinataires));
            }
            else
                Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });
    }

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des données",
        });

        const { idsTickets } = this.props;
        DataTicket._chargementLoginCompteDesTickets(idsTickets).then(responseFetch => {
            let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;
                const loginsComptesSelectionnes = objetData.map(data => {
                    const [idTicket, loginCompte] = data.split(';#');
                    return {
                        key: idTicket,
                        name: `${loginCompte} (ticket #${idTicket})`
                    };
                });
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { loginsComptesSelectionnes });
            }
            else {
                Immocom.onTraitementErreurAvecState(this, { loginsComptesSelectionnes: [] }, retourVerif, responseFetch);
            }
        });

    }

    _onFilterChanged = (filterText, tagList) => {
        let loginsComptesSelectionnes = [];

        if (!!filterText) {
            loginsComptesSelectionnes = this.state.loginsComptesSelectionnes
                .filter(tag => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0)
                .filter(tag => !this._listContainsDocument(tag, tagList));
        }

        this.setState({ loginsComptesSelectionnes });
    };

    _listContainsDocument(tag, tagList) {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }

        return tagList.filter(compareTag => compareTag.key === tag.key).length > 0;
    }

    _onChangeTagPicker = (items) => {
        if (!!items && items.length >= 1) {
            const loginsComptesSelectionnes = items.map(email => ({ key: email, name: email }));
            this.setState({ loginsComptesSelectionnes });
        }
    }

    _onRenderFooterContent = () => {
        const { onActiveBoutonEnregistrer } = this.state;
        return <Stack horizontal gap={8}>
            <PrimaryButton onClick={this._envoyer} disabled={!onActiveBoutonEnregistrer}>Envoyer</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Annuler</DefaultButton>
        </Stack>;
    };

    _onOpen = () => {
        const { idsTickets, sujet, corps, emails, idOperation, idReservation } = this.props;
        let state = {
            ...FicheEnvoiEmail.defaultState,
            sujet: sujet || "",
            corps: corps || "",
        };
        if (!!emails) state.emailsSelectionnes = [...emails];
        this.setState(
            state,
            () => { if (!!idsTickets && !!idsTickets.length) this._chargementDonnees() }
        );
    }

    render = () => {
        const { emails, from, idsTickets, isOpen, onDismiss } = this.props;
        const { sujet, corps, loginsComptesSelectionnes, emailsSelectionnes, emailsCcSelectionnes, emailsCciSelectionnes } = this.state;

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText='Envoi de mail'
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.medium}
        >
            <MessageBars
                errorMessage={this.state.errorMessage}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            {!!from && <PickerEmail
                disabled
                emails={[from]}
                label="Expéditeur"
            />}

            {!!idsTickets && !!idsTickets.length && <Fragment>
                <Label required>Comptes</Label>
                <TagPicker
                    getTextFromItem={(item) => item.name}
                    label="Liste des emails"
                    onChange={this._onChangeTagPicker}
                    onResolveSuggestions={this._onFilterChanged}
                    selectedItems={loginsComptesSelectionnes}
                    pickerSuggestionsProps={{
                        suggestionsHeaderText: "Liste d'emails",
                        noResultsFoundText: "Pas d'email correspondant"
                    }}
                />
            </Fragment>}

            {!!emails && emails.length > 0 && <Fragment>
                <PickerEmail
                    autoComplete="on"
                    emails={emailsSelectionnes}
                    label="À"
                    onChange={(emails) => this.setState({ emailsSelectionnes: emails })}
                    required={ // Requis si aucun email renseigné dans les champs Cc ou Cci
                        (emailsCcSelectionnes || []).length === 0
                        && (emailsCciSelectionnes || []).length === 0
                    }
                />
                <PickerEmail
                    autoComplete="on"
                    emails={emailsCcSelectionnes}
                    label="Cc"
                    onChange={(emails) => this.setState({ emailsCcSelectionnes: emails })}
                />
                <PickerEmail
                    autoComplete="on"
                    emails={emailsCciSelectionnes}
                    label="Cci"
                    onChange={(emails) => this.setState({ emailsCciSelectionnes: emails })}
                />
            </Fragment>}

            <EUITextField
                label="Objet"
                onChange={(event, newValue) => this.setState({ sujet: newValue })}
                required
                value={sujet}
            />

            <EUITextField
                label="Corps"
                multiline
                onChange={(event, newValue) => this.setState({ corps: newValue })}
                required
                rows={10}
                value={corps}
            />
        </Panel>;

    }
}
